import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, EditIcon, Text } from '@mercai/clever'
import { CustomAccordion } from '@/components'

import { ProfileTaxInformationProps } from './tax-information.type'
import styles from './tax-information.module.css'
import { checkIfTaxSituationIsComplete } from '../../general.constants'

export const ProfileTaxInformation = ({
  profile,
  onSelectCategory,
}: ProfileTaxInformationProps) => {
  const { t } = useTranslation('screenProfileShow')

  const [activeItems, setActiveItems] = useState(['tax-information'])

  const isComplete = checkIfTaxSituationIsComplete(profile)

  return (
    <div className={styles.core}>
      <CustomAccordion
        activeItems={activeItems}
        setActiveItems={setActiveItems}
        id="tax-information"
        title={`2. ${t('generalViewGeneralInformationTaxInformationTitle')}`}
        isComplete={isComplete}
      >
        <div className={styles['info-block']}>
          <div className={styles['info-row']}>
            <div className={styles['info-row-content']}>
              <Text className={styles['info-item']}>
                <strong>{t('generalViewTaxInformationCFDILabel')}:</strong>{' '}
                {profile?.attributes?.cfdiUsage}
              </Text>

              <Text className={styles['info-item']}>
                <strong>
                  {t('generalViewTaxInformationPaymentTypeLabel')}:
                </strong>{' '}
                {profile?.attributes?.preferredPaymentPlanType}
              </Text>

              {/* <Text className={styles['info-item']}>
                <strong>
                  {t('generalViewTaxInformationCurrencyLabel')}:
                </strong>{' '}
                {profile?.currency}
              </Text> */}
            </div>

            <Button
              variant="secondary"
              className={styles.edit}
              size="small"
              onClick={() => onSelectCategory('tax_information')}
            >
              <EditIcon />
            </Button>
          </div>
        </div>
      </CustomAccordion>
    </div>
  )
}
